<template>
  <div>
    <div class="d-inline-block ml-1">
      <b-link v-b-modal.excluir
              class="btn btn-sm btn-danger">
        Excluir Registro
        <IconSvg class="ExcluirCancelarRegistro-icon icon--sm"
                 icon="trash" />
      </b-link>
    </div>

    <div class="d-inline-block ml-1">
      <b-link v-b-modal.cancelar
              class="btn btn-sm btn-primary">
        Cancelar Registro
        <IconSvg class="ExcluirCancelarRegistro-icon icon--sm"
                 icon="close" />
      </b-link>
    </div>

    <div v-if="propRegistro.cod_motivo_alt != 30 && propRegistro.tipo_registro != 'D'"
         class="d-inline-block ml-1">
      <button v-if="propRegistro.existe_crc"
              class="btn btn-sm btn-info"
              @click="bloquearRegistro()">
        Bloquear (Determinação Judicial)
        <IconSvg class="icon--sm icons--white"
                 icon="alert" />
      </button>
    </div>

    <div v-if="propRegistro.cod_motivo_alt == 30 && propRegistro.tipo_registro != 'D'"
         class="d-inline-block ml-1">
      <button v-if="propRegistro.existe_crc"
              class="btn btn-sm btn-info"
              @click="desbloquearRegistro()">
        Desbloquear registro
        <IconSvg class="icon--sm icons--white"
                 icon="alert" />
      </button>
    </div>

    <b-modal id="excluir"
             ref="modalExcluir"
             modal-class="customExcluirModal"
             body-class="customExcluirModal_body"
             footer-class="customExcluirModal_footer"
             centered
             size="xl"
             :hide-header="true"
             @hidden="reset">
      <p>Deseja excluir o registro? Ele será excluído do Sofia-Rei.</p>

      <!--<div v-if="step === 1">
        <h4 class="titleModal d-inline-block mb-3">
          Passo 1 de 2
        </h4>
      </div>

      <div v-if="step === 2">
        <h4 class="titleModal d-inline-block mb-3">
          Passo 2 de 2
        </h4>
        <div class="form-group">
          <span class="custom-control custom-switch custom-control-inline mr-4">
            <input
              id="voltarSequencia"
              v-model="voltarSequencia"
              class="custom-control-input"
              name="voltarSequencia"
              type="checkbox">
            <label
              class="custom-control-label"
              for="voltarSequencia">Voltar a sequência do registro no Controle de Livros</label>
          </span>
        </div>
        <div
          v-for="(motivo, index) in motivosExclusao"
          :key="index"
          class="col-12">
          <div class="form-group">
            <span
              class="custom-control custom-radio custom-control-inline">
              <input
                :id="`motivo-exclusao-${index}`"
                v-model="motivoSelecionado"
                :value="motivo"
                type="radio"
                name="motivoSelecionada"
                class="custom-control-input">
              <label
                class="custom-control-label"
                :for="`motivo-exclusao-${index}`">
                {{ motivo }}
              </label>
            </span>
          </div>
        </div>
        <p />
      </div>-->

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <!--<div v-if="step === 1">
            <button class="btn btn-sm btn-light mr-2"
                    @click="cancel">
              Não
            </button>
            <button class="btn btn-sm btn-danger"
                    type="button"
                    @click="step++">
              Sim
            </button>
          </div>-->

          <div>
            <button class="btn btn-sm btn-light mr-2"
                    @click="cancel">
              Voltar
            </button>
            <button class="btn btn-sm btn-primary"
                    type="button"
                    @click="processarExcluir()">
              Continuar
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="cancelar"
             ref="modalCancelar"
             modal-class="customCancelarModal"
             body-class="customCancelarModal_body"
             footer-class="customCancelarModal_footer"
             centered
             size="xl"
             :hide-header="true"
             @hidden="reset">
      <div v-if="step === 1">
        <h4 class="titleModal d-inline-block mb-3">
          Passo 1 de 2
        </h4>
        <p>Deseja cancelar o registro? Ele <b>Não</b> será excluído do Sofia-Rei.</p>
      </div>

      <div v-if="step === 2">
        <h4 class="titleModal d-inline-block mb-3">
          Passo 2 de 2
        </h4>
        <div v-for="(motivo, index) in motivosCancelamento"
             :key="index"
             class="col-12">
          <div class="form-group">
            <span
              class="custom-control custom-radio custom-control-inline">
              <input :id="`motivo-cancelamento-${index}`"
                     v-model="motivoSelecionado"
                     :value="motivo.value"
                     type="radio"
                     :name="`motivoSelecionada-${index}`"
                     class="custom-control-input"
                     @keyup.enter="motivoSelecionado = motivo.value">
              <label class="custom-control-label"
                     :for="`motivo-cancelamento-${index}`">
                {{ motivo.text }}
              </label>
            </span>

            <div class="row">
              <div v-if="(motivoSelecionado === 30) && (index === 0)"
                   class="col-sm-12 col-md-3">
                <div class="form-group ml-3">
                  <label class="label"
                         for="data_registro">Data da Averbação</label>
                  <input id="data_registro"
                         v-model="dataAverbacao"
                         v-mask="'##/##/####'"
                         v-validate="`required|date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
                         :class="{ 'is-invalid': errors.has('date') }"
                         class="form-control form-control-sm"
                         maxlength="10"
                         name="date"
                         placeholder="00/00/0000"
                         required
                         type="text">
                  <small v-if="errors.has('date')"
                         class="invalid-feedback">{{ errors.first('date') }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <div v-if="step === 1">
            <button class="btn btn-sm btn-light mr-2"
                    @click="cancel">
              Não
            </button>
            <button class="btn btn-sm btn-danger"
                    type="button"
                    @click="nexStepCancelamento()">
              Sim
            </button>
          </div>

          <div v-if="step === 2">
            <button class="btn btn-sm btn-light mr-2"
                    @click="cancel">
              Voltar
            </button>
            <button class="btn btn-sm btn-primary"
                    :disabled="(motivoSelecionado === 30) && !dataAverbacao"
                    type="button"
                    @click="processarCancelar('CANCELAR')">
              Continuar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* services */
  import RegistrosService from "@/services/Registros"

  /* libraries */
  import moment from "moment"

  export default {
    name: 'ExcluirCancelarRegistro',
    components: { },
    props: {
      registroId: { type: [Number, String], required: true },
      propRegistro: { type: Object, default: () => ({}) }
    },
    data () {
      return {
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        step: 1,
        motivoSelecionado: '',
        dataAverbacao: '',
        voltarSequencia: false,
        motivosCancelamento: [
          {
            text: 'Por determinação Judícial. Ex: Cancelado por adoção, Averbação de proteção e Testemunha, etc.',
            value: 30
          },
          {
            text: 'Falta de sequência de numeração de registros; utilização para transporte.',
            value: 40
          }
        ],
        motivosExclusao: [
          'Fazer exclusão do registro local e CRC',
          'Fazer exclusão apenas do registro local (Futuramente será necessário a exclusão também na CRC.)'
        ]
      }
    },
    methods: {
      reset () {
        this.step = 1
        this.motivoSelecionado = ''
        this.voltarSequencia = false
        this.dataAverbacao = ''
      },
      nexStepCancelamento () {
        this.step++

        setTimeout(() => {
          const movitoCancelamento = document.getElementById('motivo-cancelamento-0')

          if (movitoCancelamento) movitoCancelamento.focus()
        }, 300)
      },
      async processarExcluir () {
        try {
          this.$root.$emit('bv::hide::modal', 'excluir')

          await RegistrosService.deleteRegistro(this.registroId, { motivo: this.motivoSelecionado, data: this.dataAverbacao })

          this.displaySuccess('Registro Excluído com Sucesso!').then(() => {
            this.$router.push({ name: 'rei_dashboard' })
          })
        } catch (e) {
          this.displayError('Erro ao Processar', e.message)
        }
      },
      async processarCancelar () {
        try {
          this.$root.$emit('bv::hide::modal', 'cancelar')

          let registro = {}

          if (this.motivoSelecionado === 40) {
            registro = { codigoMotivoAlteracao: this.motivoSelecionado }
          } else {
            registro = {
              codigoMotivoAlteracao: this.motivoSelecionado,
              dataAverbMotivoAlteracao: moment(this.dataAverbacao, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
          }

          await RegistrosService.cancelRegistro(this.registroId, registro)

          this.displaySuccess('Registro Cancelado com Sucesso!').then(() => {
            this.$router.push({ name: 'rei_dashboard' })
          })
        } catch (e) {
          this.displayError('Erro ao Processar', e.message)
        }
      },
      displaySuccess (title, text = '', html = '') {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      displayError (title, text = '', html = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      async bloquearRegistro () {
        objSwal.question.title = 'Deseja BLOQUEAR esse registro?'
        const status = await Swal.fire(objSwal.question)

        if (status.value) {
          this.$emit('onBlockUpdate', true)
        }
      },
      async desbloquearRegistro () {
        objSwal.question.title = 'Deseja DESBLOQUEAR esse registro?'
        const status = await Swal.fire(objSwal.question)

        if (status.value) {
          this.$emit('onBlockUpdate', false)
        }
      }
    }
  }
</script>

<style lang="scss">
  .ExcluirCancelarRegistro {
    &-icon, svg {
      fill: white;
      width: 10px;
    }
  }
</style>
